'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Properties = require('../Properties.js');

var _Properties2 = _interopRequireDefault(_Properties);

var _ChargeV = require('./ChargeV2.js');

var _ChargeV2 = _interopRequireDefault(_ChargeV);

var _Condition = require('./Condition.js');

var _Condition2 = _interopRequireDefault(_Condition);

var _NumberFormatUtils = require('../NumberFormatUtils');

var _NumberFormatUtils2 = _interopRequireDefault(_NumberFormatUtils);

var _CurrencyUtils = require('../CurrencyUtils');

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

var _JsonTemplates = require('../JsonTemplates');

var _JsonTemplates2 = _interopRequireDefault(_JsonTemplates);

var _ChargeV2Templates = require('./ChargeV2Templates');

var _ChargeV2Templates2 = _interopRequireDefault(_ChargeV2Templates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = {};

self.isMenuEmpty = function (menu) {
    if (!menu) return true;
    return _lodash2.default.isEmpty(menu.categories);
};

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

self.createCloneMenuRequest = function (params) {
    var destRestaurantId = params.destRestaurantId,
        sourceMenu = params.sourceMenu,
        locale = params.locale,
        sourceLocale = params.sourceLocale,
        copyCharges = params.copyCharges,
        genId = params.genId;

    // ---------------- Helper functions -----------------------

    // Recursive function to make sure the cloned menu has all the locales
    // needed. This is to fix a bug where the base menu is en_US although
    // the locale of the organization is not en_US

    var fixLocale = function fixLocale(obj) {
        if (_lodash2.default.isArray(obj)) {
            _lodash2.default.each(obj, function (value) {
                return fixLocale(value);
            });
        } else if (_lodash2.default.isObject(obj)) {
            if (obj[sourceLocale] && !obj[locale]) {
                obj[locale] = obj[sourceLocale];
                delete obj[sourceLocale];
            }
            _lodash2.default.each(obj, function (value) {
                return fixLocale(value);
            });
        };
    };

    var traverse = function traverse(obj, func) {
        if (_lodash2.default.isArray(obj)) {
            return _lodash2.default.map(obj, function (value) {
                return traverse(value, func);
            });
        } else if (_lodash2.default.isObject(obj)) {
            var keys = traverse(_lodash2.default.keys(obj), func);
            var values = traverse(_lodash2.default.values(obj), func);
            return _lodash2.default.zipObject(keys, values);
        } else {
            return func(obj);
        }
    };

    // ---------------- Helper functions -----------------------

    // Step 1: Deep clone source menu and 'null' the tags, modified and charges
    var clonedMenu = JSON.parse((0, _stringify2.default)(sourceMenu));
    clonedMenu.tags = null;
    clonedMenu.modified = null;
    clonedMenu.charges = [];
    clonedMenu.chargesV2 = copyCharges ? clonedMenu.chargesV2 : [];

    // Step 2 : Fix the ids to new ones
    var ids = _lodash2.default.union(_lodash2.default.map(clonedMenu.items, 'id'), _lodash2.default.map(clonedMenu.chargesV2, 'id'));
    var newIdsMap = _lodash2.default.zipObject(ids, _lodash2.default.map(ids, function (id) {
        return genId(id);
    }));
    clonedMenu = traverse(clonedMenu, function (id) {
        return newIdsMap[id] || id;
    });

    // Step 3 : Fix locale
    fixLocale(clonedMenu);

    return {
        type: 'set_menu',
        organizationId: destRestaurantId,
        menu: clonedMenu
    };
};

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

self.convertMenuToInternal = function (_ref) {
    var menu = _ref.menu;

    var ret = _lodash2.default.cloneDeep(menu);

    // Charges:

    ret.simplifiedCharges = [];

    var discountGroups = {};

    _lodash2.default.each(ret.chargesV2, function (charge) {
        if (_ChargeV2.default.chargeIsTax(charge)) {
            // charge is a tax: simplify and add to ret
            var simpleTax = _ChargeV2.default.simplifyCharge({ charge: charge });
            if (simpleTax) {
                ret.simplifiedCharges.push(simpleTax);
            }
        } else {
            // charge is a discount: simplify and add to one of the discount groups (by groupid)
            var groupId = _Properties2.default.get(charge, 'groupId') || charge.id;
            var simpleCharge = _ChargeV2.default.simplifyCharge({ charge: charge });
            if (simpleCharge) {
                discountGroups[groupId] = discountGroups[groupId] || [];
                discountGroups[groupId].push(simpleCharge);
            }
        }
    });

    _lodash2.default.each(discountGroups, function (group) {
        var simpleCharge = group[0];
        simpleCharge.chargeIds = _lodash2.default.map(group, 'id');
        ret.simplifiedCharges.push(simpleCharge);
    });

    // Menu:

    var simplifiedOptions = [];
    var optionSourceMap = {};

    ret.simplifiedItems = _lodash2.default.map(menu.items, function (item) {
        var simplifiedItem = _lodash2.default.cloneDeep(item);
        delete simplifiedItem.displayCondition;

        simplifiedItem.condition = _Condition2.default.simplifyCondition(item.condition);

        if (_lodash2.default.isNumber((item.stock || {}).count)) {
            simplifiedItem.condition.isSoldOut = simplifiedItem.condition.isSoldOut || (item.stock || {}).count === 0;
            simplifiedItem.condition.count = (item.stock || {}).count;
        }

        // To support old availability:
        if (!simplifiedItem.condition.availability && simplifiedItem.availability) {
            simplifiedItem.condition.availability = simplifiedItem.availability;
        }

        _lodash2.default.each(simplifiedItem.variations, function (variation) {
            // Find option type
            variation.optionType = 'extras';
            if (variation.minNumAllowed == 1 && variation.maxNumAllowed == 1) {
                variation.optionType = 'choice';
            } else if (variation.displayType == 'diff') {
                variation.optionType = 'ingredients';
            } else if (variation.illegalType) {
                variation.optionType = null;
            }

            // Add to options list
            var idx = _lodash2.default.findIndex(simplifiedOptions, variation);
            if (idx == -1) {
                simplifiedOptions.push(variation);
                optionSourceMap[simplifiedOptions.length - 1] = [item.id];
            } else {
                optionSourceMap[idx].push(item.id);
            }
        });

        return simplifiedItem;
    });

    ret.simplifiedOptions = _lodash2.default.cloneDeep(simplifiedOptions);
    _lodash2.default.each(ret.simplifiedOptions, function (option, idx) {
        option.dishes = optionSourceMap[idx];
    });

    ret.simplifiedMenus = (0, _lodash2.default)(menu.sections).reject({ id: 'trash' }).map(simplifyMenu).value();

    var trash = buildClientTrash(menu);

    if (trash) ret.trash = trash;

    return ret;
};

function simplifyMenu(complexMenu) {
    var simplifiedMenu = _lodash2.default.cloneDeep(complexMenu);
    delete simplifiedMenu.children;
    delete simplifiedMenu.displayCondition;

    simplifiedMenu.condition = _Condition2.default.simplifyCondition(complexMenu.condition);

    simplifiedMenu.sections = _lodash2.default.map(complexMenu.children, simplifySection);

    return simplifiedMenu;
}

function simplifySection(complexSection) {
    var simplifiedSection = _lodash2.default.cloneDeep(complexSection);
    delete simplifiedSection.displayCondition;

    simplifiedSection.condition = _Condition2.default.simplifyCondition(complexSection.condition);
    simplifiedSection.itemIds = simplifiedSection.itemIds || [];

    if (!simplifiedSection.condition.availability) {
        // Not assigning directly because apparently OPU returns null where I'd want it to remain undefined
        var availability = _Properties2.default.get(complexSection, 'availability', 'com.implied2.spice');
        if (availability) {
            simplifiedSection.condition.availability = availability;
        }
    }

    return simplifiedSection;
}

function buildClientTrash(menu) {
    var trashSection = _lodash2.default.find(menu.sections, function (s) {
        return s.id === 'trash';
    }) || [];
    var menus = (0, _lodash2.default)(trashSection.children).filter(function (child) {
        return getTrashInfo(child).type === 'menu';
    }).value();
    var sections = (0, _lodash2.default)(trashSection.children).filter(function (child) {
        return getTrashInfo(child).type === 'section';
    }).value();
    var dishes = (0, _lodash2.default)(trashSection.itemIds).map(function (id) {
        return _lodash2.default.find(menu.items, { id: id });
    }).value();
    var trashInfo = menus.concat(sections).concat(dishes).reduce(function (acc, cur) {
        var info = getTrashInfo(cur);

        acc[cur.id] = {
            dateRemoved: new Date(info.dateRemoved)
        };

        return acc;
    }, {});

    var simplifiedMenus = _lodash2.default.map(menus, simplifyMenu);
    var simplifiedSections = _lodash2.default.map(sections, simplifySection);

    return {
        trashInfo: trashInfo,
        menus: simplifiedMenus,
        sections: simplifiedSections,
        dishes: dishes
    };
}

function getTrashInfo(section) {
    var prop = _lodash2.default.get(section, 'properties[\'com.wix.restaurants\']', '{}');
    var parsedProp = JSON.parse(prop);
    return parsedProp.trashInfo || {};
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

function complicateObjectWithCondition(obj, ignoreForDisplay) {
    var ret = _lodash2.default.cloneDeep(obj);

    if (obj.condition) ret.condition = _Condition2.default.complicateCondition(obj.condition);
    if (obj.condition) ret.displayCondition = _Condition2.default.complicateCondition(obj.condition, ignoreForDisplay);

    if (ret.displayCondition && ret.displayCondition.conditions) {
        ret.displayCondition.conditions[0].type = obj.condition.disabled ? 'false' : 'true';
    }

    if (obj.condition && obj.condition.availability) {
        ret.availability = obj.condition.availability;
    }

    return ret;
}

//

self.convertInternalMenuToServerMenu = function (_ref2) {
    var menu = _ref2.menu,
        generateUuid = _ref2.generateUuid,
        locale = _ref2.locale;


    var ret = JSON.parse((0, _stringify2.default)(menu));

    // Menu:

    if (menu.simplifiedMenus) {
        ret.sections = _lodash2.default.map(menu.simplifiedMenus, function (menu) {
            var ret = complicateObjectWithCondition(menu);

            delete ret.sections;
            ret.children = _lodash2.default.map(menu.sections, function (section) {
                var ret = complicateObjectWithCondition(section);
                if (ret.properties && ret.properties['com.implied2.spice']) {
                    _Properties2.default.set(ret, 'availability', undefined, 'com.implied2.spice');
                }
                return ret;
            });

            return ret;
        });

        delete ret.simplifiedMenus;
    }

    if (menu.simplifiedItems) {
        ret.items = _lodash2.default.map(menu.simplifiedItems, function (item) {
            return complicateObjectWithCondition(item, { availability: true });
        });

        delete ret.simplifiedItems;
    }

    delete ret.simplifiedOptions;

    // Charges:

    var recomplicatedCharges = [];

    var taxMap = {
        0: {
            itemIds: [],
            chargeIds: []
        }
    }; // Tax Map contains [0] by default, even if it stays empty

    var taxes = _lodash2.default.filter(menu.chargesV2, { type: 'tax' });
    var discounts = _lodash2.default.filter(menu.simplifiedCharges, function (charge) {
        return charge.type != 'tax' && charge.type != 'tip';
    });
    var tips = _lodash2.default.filter(menu.simplifiedCharges, { type: 'tip' });

    var reusableTaxIds = _lodash2.default.map(taxes, 'id');

    _lodash2.default.each(menu.simplifiedItems, function (item) {
        var taxValue = (item.tax || 0) / 1000;

        taxMap[taxValue] = taxMap[taxValue] || {
            itemIds: [],
            chargeIds: []
        };

        taxMap[taxValue].itemIds.push(item.id);
    });

    _lodash2.default.each(discounts, function (discount) {
        var groupId = discount.id;
        var complexDiscount = _ChargeV2.default.complicateCharge({ charge: discount, menu: (0, _extends3.default)({}, menu, { sections: ret.sections, items: ret.items }) });

        var discountItemIds = [];
        if (!discount.deleted) {
            var chargeValues = _JsonTemplates2.default.findMatchingTemplate(complexDiscount, _ChargeV2Templates2.default).params;

            if (chargeValues) {
                discountItemIds = chargeValues.applyTo.type === 'include' ? chargeValues.applyTo.ids : _lodash2.default.map(menu.items, 'id');
            }
        }

        // Workaround for an edge case: if the discount affects no items, then the following loop
        // fails to add a complicated charge. If the discount is new then it will be ignored, and
        // if it's old then it will be overwritten as a disabled discount. This should fix it.
        var forceAddCharge = discountItemIds.length == 0;

        var reusableChargeIds = JSON.parse((0, _stringify2.default)(discount.chargeIds || []));

        var isOffOrderDiscount = discount.type === 'fixedOneTimeDiscount';
        var isManagerDiscount = discount.type === 'callcenter';

        _lodash2.default.each(taxMap, function (taxRate, taxAmount) {
            var relevantItemIds = isOffOrderDiscount || isManagerDiscount ? taxRate.itemIds : _lodash2.default.intersection(taxRate.itemIds, discountItemIds);

            if (forceAddCharge || relevantItemIds.length > 0) {
                forceAddCharge = false;
                // We generate several copies of what is essentially the same charge;
                // the only differences are the itemIds, and of course the chargeId
                var newCharge = JSON.parse((0, _stringify2.default)(complexDiscount));

                if (!discount.deleted) {
                    var countItems = newCharge.operator.operators[0].numerators[0];

                    if (countItems.operators) {
                        countItems = countItems.operators[0];
                    }

                    countItems.items.type = 'include';
                    countItems.items.ids = relevantItemIds;

                    if (discount.type === 'fixedOneTimeDiscount') {
                        var tmp = newCharge.operator.operators[1].denominators[0].denominators[0];
                        tmp.items.type = 'include';
                        tmp.items.ids = relevantItemIds;
                    }
                }

                // Get a reusable ID for this charge. If we're out of reusable IDs, generate a new
                // one and add it to the chargeIds of the relevant simplified discount in ret
                var chargeId = void 0;
                if (reusableChargeIds.length == 0) {
                    var newId = generateUuid();
                    var retDiscount = _lodash2.default.find(ret.simplifiedCharges, { id: discount.id });
                    retDiscount.chargeIds = retDiscount.chargeIds || [];
                    retDiscount.chargeIds.push(newId);
                    chargeId = newId;
                } else {
                    chargeId = reusableChargeIds.shift();
                }

                newCharge.id = chargeId;
                _Properties2.default.set(newCharge, 'groupId', groupId);

                if (taxAmount != 0) {
                    taxRate.chargeIds.push(chargeId);
                }

                if (isManagerDiscount) {
                    newCharge.operator.operators[1].operators[1].charges.ids = [chargeId];
                    _Properties2.default.set(newCharge, 'isManagerDiscount', true);
                }

                recomplicatedCharges.push(newCharge);
            }
        });

        // If we have extra chargeIds left in this discount, create empty charges for them
        _lodash2.default.each(reusableChargeIds, function (chargeId) {
            var newCharge = JSON.parse((0, _stringify2.default)(complexDiscount));
            newCharge.id = chargeId;
            newCharge.state = 'closed';
            if (!discount.deleted) {
                newCharge.operator.operators[0].numerators[0].items.ids = [];
            }
            _Properties2.default.set(newCharge, 'groupId', groupId);

            recomplicatedCharges.push(newCharge);
        });
    });

    // Now we can iterate over the taxes in taxMap and create the corresponding tax charge objects
    _lodash2.default.each(taxMap, function (val, key) {
        var taxValue = key * 1000;

        if (taxValue != 0) {
            var newCharge = _ChargeV2.default.complicateCharge({ menu: menu, charge: {
                    id: reusableTaxIds.length > 0 ? reusableTaxIds.shift() : generateUuid(),
                    type: 'tax',
                    title: 'tax',
                    data: { percent: taxValue },
                    filters: {
                        deliveryType: {
                            delivery: true,
                            takeout: true
                        },
                        platform: {},
                        menuFilter: {
                            type: 'dishes',
                            ids: val.itemIds
                        }
                    }
                } });
            newCharge.operator.numerators[0].charges.ids = val.chargeIds;

            recomplicatedCharges.push(newCharge);
        }
    });

    // If we have any leftover tax IDs, create disabled taxes with them
    _lodash2.default.each(reusableTaxIds, function (id) {
        recomplicatedCharges.push({
            id: id,
            title: 'tax',
            type: 'tax',
            displayCondition: { type: 'false' },
            condition: { type: 'false' },
            operator: { type: 'value', value: 0 },
            state: 'closed'
        });
    });

    // Convert the tip charge as well
    _lodash2.default.each(tips, function (tip) {
        var newCharge = _ChargeV2.default.complicateCharge({ charge: tip, menu: menu });
        recomplicatedCharges.push(newCharge);
    });

    // There might be charges that were not simplified in the first place when we loaded the menu,
    // but we still need to save them
    var leftoverCharges = _lodash2.default.map(_lodash2.default.filter(menu.chargesV2, function (charge) {
        return !_lodash2.default.find(recomplicatedCharges, { id: charge.id });
    }), function (charge) {
        return charge.type == 'tax' ? (0, _extends3.default)({}, charge, { state: 'closed' }) : charge;
    });

    recomplicatedCharges = recomplicatedCharges.concat(leftoverCharges);

    ret.chargesV2 = recomplicatedCharges;

    delete ret.simplifiedCharges;

    //Trash
    if (_lodash2.default.keys(_lodash2.default.get(menu, 'trash.trashInfo')).length > 0) {
        var trashSection = buildServerTrash(ret, locale);

        ret.sections = _lodash2.default.reject(ret.sections, function (s) {
            return s.id === 'trash';
        }).concat(trashSection);
    }

    delete ret.trash;

    return ret;
};

function buildServerTrash(ret, locale) {
    var trashSection = {
        id: 'trash',
        title: (0, _defineProperty3.default)({}, locale, 'Trash'),
        description: (0, _defineProperty3.default)({}, locale, ''),
        condition: {
            disabled: true
        },
        displayCondition: {
            type: 'false'
        }
    };

    var _ret$trash = ret.trash,
        trashMenus = _ret$trash.menus,
        trashSections = _ret$trash.sections;


    trashSection.children = trashMenus.map(trashSectionToMenuSection).concat(trashSections.map(trashSectionToMenuSection));

    trashSection.itemIds = ret.trash.dishes.map(function (d) {
        return d.id;
    });

    ret.items = ret.items.map(function (item) {
        return _lodash2.default.includes(trashSection.itemIds, item.id) ? setTrashInfo(item) : item;
    });

    return complicateObjectWithCondition(trashSection);

    function trashSectionToMenuSection(section) {
        if (section.sections) {
            section.children = _lodash2.default.map(section.sections, complicateObjectWithCondition);
            delete section.sections;
        }

        return setTrashInfo(complicateObjectWithCondition(section));
    }

    function setTrashInfo(item) {
        var trashInfo = getTrashInfo(item);

        if (!trashInfo.dateRemoved) {
            var wixProps = JSON.parse(_lodash2.default.get(item, 'properties[\'com.wix.restaurants\']', '{}'));

            item = (0, _extends3.default)({}, item, { properties: (0, _extends3.default)({}, item.properties, {
                    'com.wix.restaurants': (0, _stringify2.default)((0, _extends3.default)({}, wixProps, {
                        trashInfo: ret.trash.trashInfo[item.id]
                    }))
                }) });
        }

        return item;
    }
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

self.convertVariationsToInternalVariations = function (variations) {
    variations.forEach(function (variation) {
        variation.itemIds = _lodash2.default.compact(_lodash2.default.map(variation.itemIds || [], function (itemId) {

            if (!itemId) return null;
            if (typeof itemId != 'string') itemId = itemId.itemId;

            if (itemId.indexOf(':') === -1) {
                return { itemId: itemId, count: 1 };
            }

            var parts = itemId.split(':');

            return { itemId: parts[0], count: parseInt(parts[1]) }; // TODO: max if count doesn't exist?
        }));

        variation.defaults = _lodash2.default.reduce(variation.defaults || [], function (rc, itemId) {
            var parts = itemId.split(':');
            rc[parts[0]] = parseInt(parts[1]) || 1; // TODO: max if count doesn't exist?
            return rc;
        }, {});

        var prices = {};
        _lodash2.default.each(variation.prices, function (price, itemId) {
            if (itemId.indexOf(':') === -1) {
                prices[itemId] = prices[itemId] || {};
                prices[itemId][1] = price;
            } else {

                var parts = itemId.split(':');
                prices[parts[0]] = prices[parts[0]] || {};
                prices[parts[0]][parseInt(parts[1]) || 'max'] = price;
            }
        });

        variation.prices = prices;
    });

    return variations;
};

self.convertVariationsToExternalVariations = function (variations) {
    _lodash2.default.map(variations, function (variation) {
        variation.itemIds = _lodash2.default.map(variation.itemIds, function (itemId) {
            return itemId.count === 1 ? itemId.itemId : itemId.itemId + ':' + itemId.count;
        });

        var defaults = variation.defaults;
        variation.defaults = [];
        _lodash2.default.each(defaults, function (count, itemId) {
            variation.defaults.push(count === 1 ? itemId : itemId + ':' + count);
        });

        var prices = {};
        _lodash2.default.each(variation.prices || {}, function (pricesMap, itemId) {
            // Currently not supporting more than one price per variation item.
            // Take from old github version when wanting to support more in the
            // future.
            //
            prices[itemId] = (typeof pricesMap === 'undefined' ? 'undefined' : (0, _typeof3.default)(pricesMap)) == 'object' ? pricesMap[1] : pricesMap;
        });

        variation.prices = prices;

        if (_lodash2.default.isEmpty(variation.defaults)) delete variation.defaults;
        if (_lodash2.default.isEmpty(variation.prices)) delete variation.prices;

        return variation;
    });

    return variations;
};

self.formatDishPrice = function (dish, currency, locale) {
    var formatted = _NumberFormatUtils2.default.format((dish.price || 0) / 100, undefined, locale);
    return _CurrencyUtils2.default.toStr(formatted, currency, locale);
};

exports.default = self;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/Menu.ami.js
// module id = 1126
// module chunks = 0